import TimeSheets from "./index";
import EditTimeSheets from "./detail";

const router = {
  settings: {
    layout: {},
  },
  routes: [
    //employment type
    {
      path: "/time-sheets",
      component: TimeSheets,
      auth: ["admin", "user", "manager"],
      settings: {
        layout: {
          head: true,
          sider: true,
        },
      },
    },
    {
      path: "/time-sheets/:currentDate",
      component: EditTimeSheets,
      auth: ["admin", "user", "manager"],
      settings: {
        layout: {
          head: true,
          sider: true,
        },
      },
    },
  ],
};

export default router;
